<template>
<div class="ew-page">
  <navbar-dashboard v-if="!isLoadingShippingOptions || currentStep !== 2" name="Nuevo envío"></navbar-dashboard>

  <div class="ew-page__body">
    <div class="ew-card ew-wizard">
      <ol class="ew-stepper">
        <li
          class="ew-stepper__step"
          v-for="(label, i) in ['Paquete', 'Servicio', 'Direcciones', 'Pago']"
          :key="label"
          :class="{ 'is-active': currentStep === i + 1, 'is-done': currentStep > i + 1 }"
        >
          <span class="ew-stepper__index">{{ i + 1 }}</span>
          <span class="ew-stepper__label">{{ label }}</span>
          <span class="ew-stepper__line" v-if="i < 3"></span>
        </li>
      </ol>

      <!-- Paso 1: Información del Paquete -->
      <section v-if="currentStep === 1">
        <div class="ew-step-layout">
        <form @submit.prevent="calculateQuote" class="ew-step-layout__main">
          <div class="ew-addr-grid">
            <div class="ew-form-panel">
              <p class="ew-form-panel__title">Origen (Desde)</p>

              <div class="ew-form__field">
                <label class="ew-label">Seleccione dirección</label>
                <Select2 class="ew-select2" :options="optionsOrigen" v-model.trim="selectedLocation" @change="selectLocation(selectedLocation)"></Select2>
              </div>

              <div class="ew-form__field ew-form__field--relative">
                <label class="ew-label">ó capture código postal</label>
                <div class="ew-cp-group">
                  <span class="ew-flag-badge" aria-hidden="true">
                    <img :src="origin.flag" alt="" class="ew-flag">
                    MX
                  </span>
                  <input
                    type="text"
                    v-model="origin.input"
                    class="ew-input ew-input--block"
                    placeholder="C.P. Origen"
                    @keyup="checkAddressOrigin"
                    list="originSuggestions"
                    @keyup.down="onArrowDown"
                    @keyup.up="onArrowUp"
                    @keyup.enter="onEnter"
                    required
                  >
                </div>
                <ul class="ew-autocomplete" v-if="isLoading" v-show="isOpen" id="autocomplete-results-das">
                  <li
                    id="resultOrigin"
                    v-for="(result, i) in results"
                    :key="i"
                    @click="setResult(result)"
                    class="ew-autocomplete__item"
                    :class="{ 'is-active': i === arrowCounter }"
                  >{{ result.postal_code + ' - ' + result.place_name + ' - ' + result.city }}</li>
                </ul>
              </div>
            </div>

            <div class="ew-form-panel">
              <p class="ew-form-panel__title">Destino (Hasta)</p>

              <div class="ew-form__field">
                <label class="ew-label">Seleccione dirección</label>
                <Select2 class="ew-select2" :options="optionsDestination" v-model.trim="selectedLocationDes" @change="selectLocationDes(selectedLocationDes)"></Select2>
              </div>

              <div class="ew-form__field ew-form__field--relative">
                <label class="ew-label">ó capture código postal *</label>
                <div class="ew-cp-group">
                  <span class="ew-flag-badge" aria-hidden="true">
                    <img :src="destination.flag" alt="" class="ew-flag">
                    MX
                  </span>
                  <input
                    type="text"
                    v-model="destination.input"
                    class="ew-input ew-input--block"
                    placeholder="C.P. Destino"
                    @keyup="checkAddressDestination"
                    @keyup.down="onArrowDownDes"
                    @keyup.up="onArrowUpDes"
                    @keyup.enter="onEnterDes"
                    list="destinationSuggestions"
                    required
                  >
                </div>
                <ul class="ew-autocomplete" v-if="isLoadingDes" v-show="isOpenDes" id="autocomplete-results-des">
                  <li
                    id="resultOrigin"
                    v-for="(result, i) in resultsDes"
                    :key="i"
                    @click="setResultDes(result)"
                    class="ew-autocomplete__item"
                    :class="{ 'is-active': i === arrowCounterDes }"
                  >{{ result.postal_code + ' - ' + result.place_name + ' - ' + result.city }}</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="ew-package-type">
            <p class="ew-package-type__title">Tipo de paquete</p>
            <div class="ew-package-type__options">
              <label class="ew-radio-pill">
                <input class="ew-radio-pill__input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="employer" @click="setDocument">
                <span>Sobre</span>
              </label>
              <label class="ew-radio-pill">
                <input class="ew-radio-pill__input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="seeker" @click="setBox">
                <span>Paquete</span>
              </label>
            </div>
          </div>

          <div class="ew-parcels">
            <div class="ew-parcels__row" v-for="(parcel, index) in parcels" v-bind:key="index">
              <div class="ew-form__field">
                <input
                  type="number"
                  class="ew-input"
                  placeholder="Largo Cm"
                  @keyup="numberIntegerPositiveWidth"
                  v-model.trim="parcels[index].width"
                  min="1"
                  :disabled="package_type === 'document'"
                  :required="package_type !== 'document'"
                >
              </div>
              <div class="ew-form__field">
                <input
                  type="number"
                  class="ew-input"
                  placeholder="Alto Cm"
                  @keyup="numberIntegerPositiveHeight"
                  v-model.trim="parcels[index].height"
                  min="1"
                  :disabled="package_type === 'document'"
                  :required="package_type !== 'document'"
                >
              </div>
              <div class="ew-form__field">
                <input
                  type="number"
                  class="ew-input"
                  placeholder="Ancho Cm"
                  @keyup="numberIntegerPositiveDepth"
                  v-model.trim="parcels[index].depth"
                  pattern="^[0-9]"
                  min="1"
                  step="1"
                  :disabled="package_type === 'document'"
                  :required="package_type !== 'document'"
                >
              </div>
              <div class="ew-form__field">
                <input
                  type="number"
                  class="ew-input"
                  placeholder="Peso kg"
                  v-model.trim="parcels[index].weight"
                  min="0.1"
                  step="0.1"
                  @keyup="numberFloatPositiveWeight"
                  required
                >
              </div>
            </div>
            <p class="ew-parcels__hint">Ingresa peso y medidas reales para evitar cargos extra en tu próximo envío</p>
          </div>

          <div class="ew-insurance-teaser">
            <p class="ew-insurance-teaser__text">
              ¿Quieres asegurar tu envío?
              <img src="@/assets/images/icon-simbol.png" alt="" class="ew-icon-simbol">
            </p>
            <label class="ew-checkbox-row">
              <input type="checkbox" class="ew-checkbox">
              <span>Sí, quiero asegurar mi envío</span>
            </label>
          </div>

          <div class="ew-wizard__actions">
            <router-link class="ew-btn-outline" to="/dashboard">Anterior</router-link>
            <button class="ew-btn-primary" type="submit">Cotizar</button>
          </div>
        </form>

        <aside class="ew-card ew-summary-card ew-step-layout__aside">
          <p class="ew-card-title">Resumen del envío</p>
          <div class="ew-summary-detail">
            <div class="ew-summary-row"><span>Tipo de paquete</span><span>{{ package_type === 'document' ? 'Sobre' : 'Paquete' }}</span></div>
            <div class="ew-summary-row"><span>Peso</span><span>{{ isNaN(getWeightTotal(parcels)) ? 0 : getWeightTotal(parcels) }} kg</span></div>
            <div class="ew-summary-row" v-if="package_type !== 'document' && parcels[0].width && parcels[0].height && parcels[0].depth"><span>Dimensiones</span><span>{{ parcels[0].width }}×{{ parcels[0].height }}×{{ parcels[0].depth }} cm</span></div>
          </div>
        </aside>
        </div>
      </section>

      <!-- Paso 2: Selecciona tu servicio de paquetería -->
      <div v-if="isLoadingShippingOptions && currentStep === 2" class="ew-loading">
        <img src="@/assets/images/loading.gif" alt="Cargando...">
        <p>Espere un momento, estamos obteniendo los mejores precios para tu paquete</p>
      </div>

      <section v-if="currentStep === 2">
        <div v-if="!isLoadingShippingOptions">
          <h3 class="ew-section-title">Selecciona tu servicio de paquetería</h3>

          <div class="ew-step-layout">
            <div class="ew-step-layout__main">
              <div class="ew-carrier-list">
                <div class="ew-carrier-card" v-for="(so, i) in visibleShipmentOptions" v-bind:key="i">
                  <div class="ew-carrier-card__logo">
                    <img :src="so.carrier_logo_url_svg" alt="">
                  </div>

                  <div class="ew-carrier-card__info">
                    <div class="ew-carrier-card__badges" v-if="i === 0 || isFastestOption(so)">
                      <span class="ew-carrier-card__badge ew-carrier-card__badge--price" v-if="i === 0">Mejor precio</span>
                      <span class="ew-carrier-card__badge ew-carrier-card__badge--speed" v-if="isFastestOption(so)">Más rápido</span>
                    </div>
                    <div class="ew-carrier-card__name">{{ so.carrier_service_name }}</div>
                    <div class="ew-carrier-card__transit" :class="{ 'ew-area-remote': so.is_remote }">{{ getTransitInterval(so.total_transit_days, so.carrier, so.carrier_service_name, so.is_remote) }}</div>
                    <div class="ew-carrier-card__eta" v-if="!so.is_remote">Llega {{ getEstimatedDeliveryDate(so.total_transit_days) }}</div>
                    <div class="ew-carrier-card__note">Es necesario imprimir guías *</div>
                    <div class="ew-carrier-card__note--warning" v-if="so.note">{{ so.note }}</div>
                  </div>

                  <div class="ew-carrier-card__price">
                    <p class="ew-carrier-card__amount">{{ formatMXN(so.total_amount) }}</p>
                    <button type="button" class="ew-carrier-card__detail-btn" :id="'detail-' + i">Ver desglose</button>
                    <b-popover :target="'detail-' + i" placement="top" title="Desglose de precio" triggers="click blur">
                      <div class="ew-price-breakdown">
                        <div class="ew-price-breakdown__row" v-for="(service, k) in so.services" v-bind:key="k">
                          <span>{{ service.service_name }}:</span>
                          <span>{{ formatMXN(service.price) }}</span>
                        </div>
                        <div class="ew-price-breakdown__total">
                          <span>Total:</span>
                          <span>{{ formatMXN(so.total_amount) }}</span>
                        </div>
                      </div>
                    </b-popover>
                  </div>

                  <button type="button" class="ew-btn-primary" @click="catchOption(i)">Enviar</button>
                </div>

                <div class="ew-empty" v-if="visibleShipmentOptions.length === 0">
                  <ph-icon name="package" />
                  <p class="ew-empty__title">Ningún servicio disponible</p>
                  <p class="ew-empty__text">Intenta de nuevo más tarde o comunícate con soporte.</p>
                </div>

                <div class="ew-wizard__actions ew-wizard__actions--end">
                  <button class="ew-btn-outline" type="button" @click="prevStep">Anterior</button>
                </div>
              </div>
            </div>

            <aside class="ew-card ew-summary-card ew-step-layout__aside">
              <p class="ew-card-title">Resumen del envío</p>
              <div class="ew-summary-detail">
                <div class="ew-summary-row"><span>Tipo de paquete</span><span>{{ package_type === 'document' ? 'Sobre' : 'Paquete' }}</span></div>
                <div class="ew-summary-row"><span>Peso</span><span>{{ isNaN(getWeightTotal(parcels)) ? 0 : getWeightTotal(parcels) }} kg</span></div>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <!-- Paso 3: Ingresar direcciones -->
      <section v-if="currentStep === 3">
        <form @submit.prevent="createShipment" novalidate>
          <h3 class="ew-section-title">Ingresar direcciones</h3>

          <div class="ew-step-layout">
            <div class="ew-step-layout__main">
              <div class="ew-addr-grid">
                <div class="ew-address-panel">
                  <div class="ew-address-panel__header">
                    <span>Origen</span>
                    <span class="ew-flag-badge ew-flag-badge--header" aria-hidden="true">
                      <img :src="origin.flag" alt="" class="ew-flag">
                      MX
                    </span>
                  </div>
                  <div class="ew-address-panel__body">
                    <div class="ew-form__field">
                      <label class="ew-label">Nombre y apellido *</label>
                      <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.origin_direction.full_name.$error }" @blur="$v.origin_direction.full_name.$touch()" minlength="2" maxlength="35" v-model.trim="origin_direction.full_name" placeholder="John Doe" required>
                      <div class="ew-field-error" v-if="$v.origin_direction.full_name.$error">Ingresa el nombre completo</div>
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Teléfono *</label>
                      <input type="tel" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.origin_direction.phone.$error }" @blur="$v.origin_direction.phone.$touch()" pattern="[0-9]{3,25}" v-model.trim="origin_direction.phone" placeholder="123456789" required>
                      <div class="ew-field-error" v-if="$v.origin_direction.phone.$error">Ingresa un teléfono válido</div>
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Correo electrónico *</label>
                      <input type="email" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.origin_direction.email.$error }" @blur="$v.origin_direction.email.$touch()" v-model.trim="origin_direction.email" placeholder="nombre@tucorreo.com" required>
                      <div class="ew-field-error" v-if="$v.origin_direction.email.$error">Ingresa un correo válido</div>
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Calle *</label>
                      <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.origin_direction.address.$error }" @blur="$v.origin_direction.address.$touch()" minlength="2" maxlength="25" v-model.trim="origin_direction.address" placeholder="Av. Josefa Ortiz" required>
                      <div class="ew-field-error" v-if="$v.origin_direction.address.$error">Ingresa la calle</div>
                    </div>
                    <div class="ew-form__row">
                      <div class="ew-form__field">
                        <label class="ew-label">No. Ext *</label>
                        <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.origin_direction.number.$error }" @blur="$v.origin_direction.number.$touch()" minlength="1" maxlength="5" v-model.trim="origin_direction.number" placeholder="309" required>
                      </div>
                      <div class="ew-form__field">
                        <label class="ew-label">No. Int</label>
                        <input type="text" class="ew-input ew-input--block" minlength="1" maxlength="5" v-model.trim="origin_direction.intNumber" placeholder="J-45">
                      </div>
                    </div>
                    <div class="ew-field-error" v-if="$v.origin_direction.number.$error">Ingresa el número exterior</div>
                    <div class="ew-form__field">
                      <label class="ew-label">Referencia <small>(opcional)</small></label>
                      <input type="text" class="ew-input ew-input--block" minlength="2" maxlength="35" v-model.trim="origin_direction.reference_of_origin" placeholder="Casa verde">
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Colonia *</label>
                      <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.origin_direction.colony.$error }" @blur="$v.origin_direction.colony.$touch()" maxlength="35" v-model.trim="origin_direction.colony" placeholder="Independencia" required>
                      <div class="ew-field-error" v-if="$v.origin_direction.colony.$error">Ingresa la colonia</div>
                    </div>
                    <div class="ew-form__row">
                      <div class="ew-form__field">
                        <label class="ew-label">Código postal *</label>
                        <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.origin_direction.postal_code.$error }" @blur="$v.origin_direction.postal_code.$touch()" maxlength="12" v-model.trim="origin_direction.postal_code" required>
                      </div>
                      <div class="ew-form__field">
                        <label class="ew-label">Estado y ciudad *</label>
                        <input type="text" class="ew-input ew-input--block" minlength="2" maxlength="35" v-model.trim="origin_direction.city" required disabled>
                      </div>
                    </div>
                    <div class="ew-field-error" v-if="$v.origin_direction.postal_code.$error">Ingresa el código postal</div>
                    <label class="ew-checkbox-row">
                      <input type="checkbox" class="ew-checkbox" @change="setSaveLocationOrigen">
                      <span>Guardar dirección</span>
                    </label>
                  </div>
                </div>

                <div class="ew-address-panel">
                  <div class="ew-address-panel__header">
                    <span>Destino</span>
                    <span class="ew-flag-badge ew-flag-badge--header" aria-hidden="true">
                      <img :src="destination.flag" alt="" class="ew-flag">
                      MX
                    </span>
                  </div>
                  <div class="ew-address-panel__body">
                    <div class="ew-form__field">
                      <label class="ew-label">Nombre y apellido *</label>
                      <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.destination_direction.full_name.$error }" @blur="$v.destination_direction.full_name.$touch()" minlength="2" maxlength="35" v-model.trim="destination_direction.full_name" placeholder="John Doe" required>
                      <div class="ew-field-error" v-if="$v.destination_direction.full_name.$error">Ingresa el nombre completo</div>
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Teléfono *</label>
                      <input type="tel" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.destination_direction.phone.$error }" @blur="$v.destination_direction.phone.$touch()" pattern="[0-9]{3,25}" v-model.trim="destination_direction.phone" placeholder="123456789" required>
                      <div class="ew-field-error" v-if="$v.destination_direction.phone.$error">Ingresa un teléfono válido</div>
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Correo electrónico *</label>
                      <input type="email" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.destination_direction.email.$error }" @blur="$v.destination_direction.email.$touch()" v-model.trim="destination_direction.email" placeholder="nombre@tucorreo.com" required>
                      <div class="ew-field-error" v-if="$v.destination_direction.email.$error">Ingresa un correo válido</div>
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Calle *</label>
                      <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.destination_direction.address.$error }" @blur="$v.destination_direction.address.$touch()" minlength="2" maxlength="25" v-model.trim="destination_direction.address" placeholder="Av. Josefa Ortiz" required>
                      <div class="ew-field-error" v-if="$v.destination_direction.address.$error">Ingresa la calle</div>
                    </div>
                    <div class="ew-form__row">
                      <div class="ew-form__field">
                        <label class="ew-label">No. Ext *</label>
                        <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.destination_direction.number.$error }" @blur="$v.destination_direction.number.$touch()" minlength="2" maxlength="5" v-model.trim="destination_direction.number" placeholder="309" required>
                      </div>
                      <div class="ew-form__field">
                        <label class="ew-label">No. Int</label>
                        <input type="text" class="ew-input ew-input--block" minlength="2" maxlength="5" v-model.trim="destination_direction.intNumber" placeholder="J-45">
                      </div>
                    </div>
                    <div class="ew-field-error" v-if="$v.destination_direction.number.$error">Ingresa el número exterior</div>
                    <div class="ew-form__field">
                      <label class="ew-label">Referencia <small>(opcional)</small></label>
                      <input type="text" class="ew-input ew-input--block" minlength="2" maxlength="35" v-model.trim="destination_direction.reference_of_origin" placeholder="Casa verde">
                    </div>
                    <div class="ew-form__field">
                      <label class="ew-label">Colonia *</label>
                      <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.destination_direction.colony.$error }" @blur="$v.destination_direction.colony.$touch()" minlength="5" maxlength="35" placeholder="Independencia" v-model.trim="destination_direction.colony" required>
                      <div class="ew-field-error" v-if="$v.destination_direction.colony.$error">Ingresa la colonia</div>
                    </div>
                    <div class="ew-form__row">
                      <div class="ew-form__field">
                        <label class="ew-label">Código postal *</label>
                        <input type="text" class="ew-input ew-input--block" :class="{ 'is-invalid': $v.destination_direction.postal_code.$error }" @blur="$v.destination_direction.postal_code.$touch()" maxlength="12" v-model.trim="destination_direction.postal_code" required>
                      </div>
                      <div class="ew-form__field">
                        <label class="ew-label">Estado y ciudad *</label>
                        <input type="text" class="ew-input ew-input--block" minlength="5" maxlength="35" v-model.trim="destination_direction.city" required disabled>
                      </div>
                    </div>
                    <div class="ew-field-error" v-if="$v.destination_direction.postal_code.$error">Ingresa el código postal</div>
                    <label class="ew-checkbox-row">
                      <input type="checkbox" class="ew-checkbox" @change="setSaveLocationDestination">
                      <span>Guardar dirección</span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="ew-card ew-content-card">
                <p class="ew-card-title">Contenido del envío</p>
                <input
                  type="text"
                  class="ew-input ew-input--block"
                  :class="{ 'is-invalid': $v.description_of_the_content.$error }"
                  @blur="$v.description_of_the_content.$touch()"
                  v-model="description_of_the_content"
                  placeholder="Descripción del contenido"
                  required
                >
                <div class="ew-field-error" v-if="$v.description_of_the_content.$error">Describe qué envías</div>
              </div>

              <div class="ew-wizard__actions">
                <button class="ew-btn-outline" type="button" @click="prevStep">Anterior</button>
                <button type="submit" class="ew-btn-primary">Siguiente</button>
              </div>
            </div>

            <aside class="ew-card ew-summary-card ew-step-layout__aside">
              <div class="ew-summary-card__carrier">
                <img :src="shippingOptions[selectedShippingOptionIndex].carrier_logo_url_svg" alt="">
                <p>{{ shippingOptions[selectedShippingOptionIndex].carrier_service_name }}</p>
              </div>

              <div class="ew-summary-route">
                <div class="ew-summary-route__row">
                  <span>De:</span>
                  <div>
                    <p>{{ origin_direction.postal_code }}, {{ getCity(origin_direction.city) }}</p>
                    <p>México</p>
                  </div>
                </div>
                <div class="ew-summary-route__row">
                  <span>A:</span>
                  <div>
                    <p>{{ destination_direction.postal_code }}, {{ getCity(destination_direction.city) }}</p>
                    <p>México</p>
                  </div>
                </div>
              </div>

              <div class="ew-summary-detail">
                <div class="ew-summary-row"><span>Tipo de paquete</span><span>{{ package_type === 'document' ? 'Sobre' : 'Paquete' }}</span></div>
                <div class="ew-summary-row"><span>Peso total</span><span>{{ weightTotal }} kg</span></div>
                <div class="ew-summary-row" v-if="description_of_the_content"><span>Contenido</span><span>{{ description_of_the_content }}</span></div>
                <div class="ew-summary-row"><span>Precio neto</span><span>{{ formatMXN(netPrice) }}</span></div>
                <div class="ew-summary-row" v-if="overweight > 0"><span>Sobrepeso anterior</span><span>{{ overweight }} kg</span></div>
                <div class="ew-summary-row" v-if="cost_overweight > 0"><span>Precio sobrepeso</span><span>{{ formatMXN(cost_overweight) }}</span></div>
                <div class="ew-summary-total"><span>Total</span><span>{{ formatMXN(total) }}</span></div>
              </div>
            </aside>
          </div>
        </form>
      </section>

      <!-- Paso 4: Selecciona pago -->
      <section v-if="currentStep === 4">
        {{ addEventPixeleFacebook() }}
        <div class="ew-step-layout">
          <div class="ew-card ew-pay-card ew-step-layout__main">
            <p class="ew-card-title">Método de pago</p>

            <form @submit.prevent>
              <div class="ew-pay-options">
                <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'paypal' }">
                  <input type="radio" name="paymentMethod" @change="getLinkPaypal" v-on:click="paymentMethod = 'paypal'">
                  <img class="ew-pay-option__logo" src="@/assets/images/paypal.png" alt="">
                  <span class="ew-pay-option__label">PayPal</span>
                </label>

                <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'paypal-plus' }">
                  <input type="radio" name="paymentMethod" v-on:click="paymentMethod = 'paypal-plus'">
                  <img class="ew-pay-option__logo" src="@/assets/images/card-paypal.png" alt="">
                  <span class="ew-pay-option__label">Pago con tarjeta</span>
                </label>

                <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'oxxo' }">
                  <input type="radio" name="paymentMethod" v-on:click="paymentMethod = 'oxxo'">
                  <img class="ew-pay-option__logo" src="@/assets/images/oxxopay_brand.png" alt="">
                  <span class="ew-pay-option__label">OXXO</span>
                </label>

                <label class="ew-pay-option" :class="{ 'is-selected': paymentMethod === 'monedero', 'is-disabled': monederoDisabled }">
                  <input type="radio" name="paymentMethod" v-on:click="paymentMethod = 'monedero'" :disabled="monederoDisabled || monederoSubmitting">
                  <ph-icon name="wallet" />
                  <span class="ew-pay-option__label">
                    Monedero electrónico
                    <small class="ew-pay-option__hint" v-if="monederoLoading">Consultando saldo…</small>
                    <small class="ew-pay-option__hint" v-else-if="monederoSubmitting">Procesando tu pago…</small>
                    <small class="ew-pay-option__hint" v-else-if="monederoDisabled">Saldo insuficiente</small>
                  </span>
                  <span class="ew-pay-option__balance">{{ monederoLoading ? '' : formatMXN(total_monedero) }}</span>
                </label>
              </div>

              <p class="ew-pay-hint" v-if="paymentMethod === 'oxxo'">Generaremos un código de barras. Pagas en cualquier tienda OXXO y tu guía se activa en cuanto se confirme el pago (puede tardar hasta un día hábil).</p>
              <p class="ew-pay-hint" v-if="paymentMethod === 'paypal-plus'">Ingresa los datos de tu tarjeta en la ventana segura de PayPal. No guardamos los datos de tu tarjeta.</p>

              <div class="ew-wizard__actions">
                <button class="ew-btn-outline" type="button" @click="deleteShipment">Anterior</button>

                <a
                  :href="paypalLink"
                  class="ew-btn-primary"
                  v-if="paypalLink !== '' && paymentMethod === 'paypal'"
                >Pagar</a>

                <button
                  type="button"
                  id="miniBrowserInitiateCheckout"
                  class="ew-btn-primary"
                  @click="initIframePayPalPlus"
                  v-if="paypalpluslink !== '' && paymentMethod === 'paypal-plus'"
                >Pagar con tarjeta</button>

                <button
                  type="button"
                  class="ew-btn-primary"
                  v-if="paymentMethod === 'oxxo'"
                  v-on:click="paymentOXXO"
                  :disabled="payDisabled"
                >Pagar</button>

                <button
                  type="button"
                  class="ew-btn-primary ew-pay-submit"
                  :class="{ 'is-loading': monederoSubmitting }"
                  v-if="paymentMethod === 'monedero'"
                  v-on:click="paymentMonedero"
                  :disabled="monederoDisabled || monederoSubmitting"
                >
                  <span class="ew-spinner" v-if="monederoSubmitting" aria-hidden="true"></span>
                  <span>{{ monederoSubmitting ? 'Procesando…' : 'Pagar con monedero' }}</span>
                </button>
              </div>
              <div class="ew-field-error" v-if="paymentError">{{ paymentError }}</div>
              <p class="ew-pay-security">Pago seguro. Te enviaremos la guía a tu correo en cuanto se confirme el pago.</p>
            </form>
          </div>

          <aside class="ew-card ew-summary-card ew-step-layout__aside">
            <p class="ew-card-title">Resumen de compra</p>
            <div class="ew-summary-card__carrier">
              <img :src="visibleShipmentOptions[selectedShippingOptionIndex].carrier_logo_url_svg" alt="">
              <p>{{ visibleShipmentOptions[selectedShippingOptionIndex].carrier_service_name }}</p>
            </div>
            <div class="ew-summary-detail">
              <div class="ew-summary-row">
                <span>Destino</span>
                <span>{{ destination_direction.full_name }}<br>C.P. {{ destination_direction.postal_code }}</span>
              </div>
              <div class="ew-summary-row"><span>Tipo de paquete</span><span>{{ package_type === 'document' ? 'Sobre' : 'Paquete' }}</span></div>
              <div class="ew-summary-row"><span>Peso total</span><span>{{ weightTotal }} kg</span></div>
              <div class="ew-summary-row" v-if="description_of_the_content"><span>Contenido</span><span>{{ description_of_the_content }}</span></div>
              <div class="ew-summary-total"><span>Total</span><span>{{ visibleShipmentOptions[selectedShippingOptionIndex].currency }} {{ formatMXN(total) }}</span></div>
            </div>
          </aside>
        </div>
      </section>
    </div>
  </div>

  <div id="ppplusDiv"></div>
</div>
</template>

<script>
import axios from 'axios';
import commons from '../commons';
import api from "../commons/api";
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Navbar from './Header/Navbar';
import service from "../commons/api";
import Select2 from 'v-select2-component';
import { formatMXN } from '../commons/currency';
import PhIcon from './icons/PhIcon';
import moment from 'moment';
import 'moment/locale/es';
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators';
export default {
  name: 'NewShipmentFlowFromDashboard',
  data () {
    return {
      locations: [],
      optionsOrigen: [],
      optionsDestination: [],
      saveLocationOrigen : false,
      saveLocationDestination : false,
      locationsDes: [],
      selectedLocation: 'Direcciones',
      selectedLocationDes: 'Direcciones',
      //Para el codigo postal de origen
      isOpen: false,
      results: [],
      scroll:0,
      isLoading: false,
      arrowCounter: -1,
      //Para el codigo postal de destino
      isOpenDes: false,
      resultsDes: [],
      scrollDes:0,
      isLoadingDes: false,
      arrowCounterDes: -1,
      paypalplay:null,
      paypalpluslink:"",
      newShip: false,
      idUser: null,
      isLoging: false,
      isOpenDetail: [],
      paymentMethod: "",
      payDisabled: false,
      monederoDisabled: true,
      monederoLoading: true,
      monederoSubmitting: false,
      paymentError: '',
      total_monedero: 0,
      quotingLocked: true,
      paypalLink: "",
      payment_id:"",
      shipmentId: null,

      origin: {
        flag: "https://restcountries.eu/data/mex.svg",
        country_code: 'MX',
        input: ''
      },
      destination: {
        flag: "https://restcountries.eu/data/mex.svg",
        country_code: 'MX',
        input: ''
      },
      //>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
      weightTotal:0,
      netPrice: 0,
      total: 0,
      overweight: 0,
      cost_overweight: 0,
      countries: [],
      quotingLocked: true,
      user:{
        first_names:"",
        last_names:"",
        email:"",
        active: false
      },
      step: 1,
      selectedShippingOptionIndex: -1,

      package_type: 'box',

      availableCarriers: [
        {
          label: 'DHL',
          value: 'dhl'
        },
        {
          label: 'Redpack',
          value: 'redpack'
        },
        {
          label: "FedEx",
          value: "fedex"
        },
         {
          label: "AM/PM",
          value: "ampm"
        },
        {
         label: "Estafeta",
         value: "Estafeta"
       }
      ],
      visibleShipmentSpeed: [],
      visibleCarriers: [],
      visibleShipmentOptios: [],

      origin_direction: {
        full_name: '',
        email: '',
        phone: '',
        address: '',
        number: '',
        intNumber: '',
        reference_of_origin: '',
        colony: '',
        postal_code: '',
        state_code: '',
        city: '',
        country_code: 'MX'
      },

      destination_direction: {
        full_name: '',
        email: '',
        phone: '',
        address: '',
        number: '',
        intNumber: '',
        reference_of_origin: '',
        colony: '',
        postal_code: '',
        state_code: '',
        city: '',
        country_code: 'MX'
      },
      shipment_ecommerce: null,
      description_of_the_content: '',
      package_insurance: false,

      insurance_information: {
        package_value: null,
        responsible_for_the_package: null,
        mail_responsible: null,
        cost: null
      },

      parcels: [
        {
          depth: '',
          width: '',
          height: '',
          weight: ''
        }
      ],

      requestBody: {
        origin_direction: {
          country_code: '',
          postal_code: '',
          city: '',
          suburb: ''
        },

          parcels: [
            {
              weight: '',
              height: '',
              depth: '',
              width: ''
            }
          ],
          destination_direction: {
            country_code: '',
            postal_code: '',
            city: '',
            suburb: ''
          },
          package_type: ''
          ,
          user: ''
       },

      }
  },
  watch: {
    visibleCarriers: function (oldValue, newValue) {
      let vc = []
      let vss = []

      if (!this.visibleCarriers.length) {
        vc = this.availableCarriers.map(c => c.value)
      } else {
        vc = this.visibleCarriers
      }

      if (!this.visibleShipmentSpeed.length) {
        vss = ['1-2', '1-3', '2-5']
      } else {
        vss = this.visibleShipmentSpeed
      }
      this.filter(vc, vss)
    },

    visibleShipmentSpeed: function (oldValue, newValue) {
      let vc = []
      let vss = []

      if (!this.visibleCarriers.length) {
        vc = this.availableCarriers.map(c => c.value)
      } else {
        vc = this.visibleCarriers
      }

      if (!this.visibleShipmentSpeed.length) {
        vss = ['1-2', '1-3', '2-5']
      } else {
        vss = this.visibleShipmentSpeed
      }
      this.filter(vc, vss)
    },

    shippingOptions: function (oldValue, newValue) {
      if (newValue.length) {
        this.visibleShipmentOptions = newValue
      } else {
        this.visibleShipmentOptions = this.shippingOptions
      }
    }
  },
  methods: {
    formatMXN,
    getEstimatedDeliveryDate(transitDays) {
      return moment().add(transitDays, 'days').format('dddd D [de] MMMM')
    },
    isFastestOption(so) {
      if (!this.visibleShipmentOptions.length) return false
      const min = Math.min(...this.visibleShipmentOptions.map(o => o.total_transit_days))
      return so.total_transit_days === min
    },
    numberIntegerPositiveWidth(event){
      let index = 0
      if (Number(event.target.value) > 0) {
        this.parcels[index].width = Math.ceil(Number(event.target.value)).toString()
      }
    },
    numberIntegerPositiveHeight(event){
      let index = 0
      if (Number(event.target.value) > 0) {
        this.parcels[index].height = Math.ceil(Number(event.target.value)).toString()
      }
    },
    numberIntegerPositiveDepth(event){
      let index = 0
      if (Number(event.target.value) > 0) {
        this.parcels[index].depth = Math.ceil(Number(event.target.value)).toString()
      }
    },
    numberFloatPositiveWeight(event){
      let index = 0
       if (Number(event.target.value) > 0) {
        this.parcels[index].weight = Number(event.target.value).toString();
       }

    },

  paymentOXXO() {
    if ("oxxo" === this.paymentMethod) {
      this.payDisabled = true;
      this.paymentError = '';
      axios
        .post(
          `${commons.apiURL}/api/v1/payments/conekta/oxxo/${this.shipmentId}`,
          { email: this.user.email }
        )
        .then(response => {
          if (response.data.message === "ok") {
            this.payDisabled = false;
            this.$router.push({
              path: "/payments/result/success",
              query: {
                oxxo: "true",
                reference: response.data.reference,
                email: this.user.email
              }
            });
          } else {
            this.payDisabled = false;
            this.paymentError = 'No se pudo generar el pago en Oxxo. Intenta de nuevo.';
          }
        })
        .catch(() => {
          this.payDisabled = false;
          this.paymentError = 'No se pudo generar el pago en Oxxo. Intenta de nuevo.';
        });
    }
  },

  paymentMonedero() {
    // `monederoDisabled` significa "saldo insuficiente" y controla el texto
    // del radio (línea "Saldo insuficiente"); reusarlo para el estado "en
    // curso" hacía que ese mismo texto apareciera un instante al dar clic
    // en Pagar, aunque el saldo sí alcanzara. `monederoSubmitting` es el
    // estado propio del cobro en curso, con su propio loader en el botón.
    if ("monedero" === this.paymentMethod && !this.monederoDisabled && !this.monederoSubmitting) {
      this.monederoSubmitting = true;
      this.paymentError = '';
      axios
        .post(
          `${commons.apiURL}/api/v1/payments/monedero/${this.shipmentId}`,
          { email: this.user.email, user: this.idUser }
        )
        .then(response => {
          if (response.data.message === "ok") {
            this.$router.push({
              path: "/payments/result/success",
              query: {
                monedero: "true",
                email: this.user.email
              }
            });
          } else {
            this.monederoSubmitting = false;
            this.paymentError = response.data.error || 'No se pudo pagar con monedero. Intenta de nuevo.';
          }
        })
        .catch(() => {
          this.monederoSubmitting = false;
          this.paymentError = 'No se pudo pagar con monedero. Intenta de nuevo.';
        });
    }
  },
    selectedShippingOptionEvent(index){
      if (this.selectedShippingOptionIndex === index) {
        this.selectedShippingOptionIndex = -1
      } else {
        this.selectedShippingOptionIndex = index
        this.setSelectedShippingOption(this.shippingOptions[this.selectedShippingOptionIndex])
      }


    },
    sortServices(){
        var options =  this.shippingOptions.sort(function(a, b) {
            return a.total_amount - b.total_amount;
        })
        this.setShippingOptions(options)
    },
    getTransitInterval(transitDays,carrier, carrierServiceName, isRemote) {
      if (!isRemote) {
        if (carrierServiceName === "EXPRESS DOMESTIC 10:30") {
          return "Día siguiente antes de las 10:30";
        } else if (carrierServiceName === "EXPRESS DOMESTIC 12:00") {
          return "Día siguiente antes de las 12:30";
        } else if (carrierServiceName === "EXPRESS DOMESTIC") {
          return "Día siguiente";
        } else if (carrierServiceName === "ECONÓMICO") {
          return "De 1 a 4 Días";
        } else if (carrierServiceName === "EXPRESS" && carrier !== "ampm") {
          return "Día siguiente";
        } else if (carrierServiceName === "ECOEXPRESS") {
          return "Estándar 1 a 5 días";
        } else if (carrierServiceName === "Standard Overnight") {
          return "De 1 a 2 Días ";
        } else if (carrierServiceName === "FedEx Economy") {
          return "De 1 a 4 Días";
        } else if (carrierServiceName === "Priority Overnight") {
          return "Día siguiente";
        }  else if (carrierServiceName === "EXPRESS" && carrier === "ampm") {
          return "Expréss 1 a 2 días";
        } else if (carrierServiceName === "ESTANDAR") {
          return "Estándar 2 a 6 días";
        }  else if (carrierServiceName === "Envío Economico" && carrier == "Estafeta") {
         return "De 3 a 5 Días";
        }
        else if (carrierServiceName === "TERRESTRE" && carrier == "Estafeta") {
          return "De 1 a 5 días";
        }
        else if (carrierServiceName === "TERRESTRE" && carrier == "fedex") {
          return "De 2 a 5 días";
        }
        else if (carrierServiceName.toUpperCase() === "STANDARD_OVERNIGHT") {
         return "De 1 a 2 días";
       }
       else if (carrierServiceName.toUpperCase() === "FEDEX_EXPRESS_SAVER") {
         return "De 2 a 5 días";
       }
       else if (carrierServiceName.toUpperCase() === "J&TEXPRESS") {
         return "De 2 a 5 días";
       }
       else if (carrierServiceName.toUpperCase() === "ENVÍO ECONOMICO" && carrier.toUpperCase() == "REDPACK") {
         return "De 2 a 5 días";
       }
        else {
          return "Día siguiente";
        }
      } else {
        return "Entrega en un área Remota";
      }
    },
    getTransitIntervalAlt (transitDays) {
      if (transitDays >= 0 && transitDays <= 2) {
        return '1-2'
      } else if (transitDays >= 1 && transitDays <= 3) {
        return '1-3'
      } else if (transitDays >= 2 && transitDays <= 5) {
        return '2-5'
      }
    },

    filter (visibleCarriers, visibleShipmentSpeed) {
      const op = this.shippingOptions.filter(sp => {
        if (
          visibleCarriers.includes(sp.carrier) &&
          visibleShipmentSpeed.includes(
            this.getTransitIntervalAlt(sp.total_transit_days)
          )
        ) {
          return true
        }

        return false
      })

      this.visibleShipmentOptios = op
    },

    addParcel () {
      this.parcels.push({
        depth: '',
        width: '',
        height: '',
        weight: ''
      })
    },
    removeParcel (index) {
      if (this.parcels.length > 1) {
        this.parcels.splice(index, 1)

      }
    },
    nextStep () {
      if (this.currentStep < 6) {
        this.step++
      }
    },
    prevStep () {
      if (this.currentStep > 1) {
        this.step--
      }
    },
    catchOption(index) {
      if(this.idUser !== null)
      {
         //si los usuarios no están bloqueados
         if(this.user.active == true && this.idUser != "635722ca498b59763159eb99" && this.idUser != "634df378498b597631b2bf34" && this.idUser != "6359be1b498b5976318f5013"
         && this.idUser != "636297ddffe03f3b69032fa7" && this.idUser != "633337bf0aaf5a4ea81a71f4"  && this.user.email != 'arguellom1324@gmail.com')
         {
          this.selectedShippingOptionIndex = index;
          this.setSelectedShippingOption(
            this.visibleShipmentOptions[this.selectedShippingOptionIndex]
          );
          this.getOverWeight();
          this.getPrepaidsUser();
          this.nextStep();
        }
      }
      else
      {
        window.location.href = '/signin';
      }
    },
    getOverWeight()
    {
      this.overweight = 0;
      this.cost_overweight = 0;
      this.netPrice = this.selectedShippingOption.total_amount;
      this.total = this.selectedShippingOption.total_amount;
      if (localStorage.getItem("ew-user-id") !== null) {
      console.log(`${commons.apiURL}/api/v1/shipments/all/${localStorage.getItem('ew-user-id')}/overweight`);
          axios
          .get(`${commons.apiURL}/api/v1/shipments/all/${localStorage.getItem('ew-user-id')}/overweight`)
          .then(response => {
            console.log(response.data);
            let shipmentsWithOverweight = response.data;
            for(var i = 0; i < shipmentsWithOverweight.length; i++)
            {
                if(shipmentsWithOverweight[i].overweight != null && shipmentsWithOverweight[i].cost_overweight != null)
                {
                  this.overweight += parseFloat(shipmentsWithOverweight[i].overweight);
                  this.cost_overweight += parseFloat(shipmentsWithOverweight[i].cost_overweight);
                }
            }
            this.total =  parseFloat(this.total) + parseFloat(this.cost_overweight);

          })
          .catch(error => {
            console.error(error)
          })
      }
    },
    getPrepaidsUser () {
      this.total_monedero = 0
      this.monederoDisabled = true
      this.monederoLoading = true
      // El saldo se pide al servidor (suma completa dentro de Mongo), no se
      // suma aquí desde la lista de movimientos: esa lista está acotada a los
      // 1000 más recientes y para cuentas grandes daba un saldo falso
      // (negativo) que bloqueaba el pago con monedero.
      axios
        .get(`${commons.apiURL}/api/v1/prepaid/getTotalAmount/${localStorage.getItem('ew-user-id')}`)
        .then(response => {
            this.total_monedero = parseFloat(response.data.total_amount) || 0
            this.monederoDisabled = this.total_monedero < this.total
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.monederoLoading = false
        })
    },

    listAllShippingOptions () {
      this.sortServices()
      this.visibleShipmentOptions = this.shippingOptions
      let vc = []
      let vss = []

      if (!this.visibleCarriers.length) {
        vc = this.availableCarriers.map(c => c.value)
      } else {
        vc = this.visibleCarriers
      }

      if (!this.visibleShipmentSpeed.length) {
        vss = ['1-2', '1-3', '2-5']
      } else {
        vss = this.visibleShipmentSpeed
      }
      this.filter(vc, vss)
    },
    formatAddress (countryCode, rawAddress) {
      let address = {
        country_code: countryCode
      }

      if (rawAddress.includes(' - ')) {
        const addressList = rawAddress.split(' - ')

        address['postal_code'] = addressList[0]

        if (addressList.length === 3) {
          address['suburb'] = addressList[1]
          address['city'] = addressList[2]
        } else {
          address['city'] = addressList[1]
        }
        console.log(address);

        return address
      }

      address['postal_code'] = rawAddress

      return address
    },
    initialValue(){
      this.origin_direction.postal_code = this.origin.input.split('-')[0].trim()
      if (this.origin_direction.postal_code !== "") {
          axios.get(`${commons.apiURL}/api/v1/postalcode?zipCode=${this.origin_direction.postal_code}&country=MX`).then((response)=>{
              if(response.data[0].city !== undefined)
                this.origin_direction.city = response.data[0].state +", " + response.data[0].city
              else
                this.origin_direction.city = response.data[0].state
          })
      }

      this.origin_direction.colony = this.origin.input.split('-')[1].trim()

      this.destination_direction.postal_code = this.destination.input.split('-')[0].trim()
      if (this.destination_direction.postal_code !== "") {
        axios.get(`${commons.apiURL}/api/v1/postalcode?zipCode=${this.destination_direction.postal_code}&country=MX`).then((response)=>{
          if(response.data[0].city !== undefined)
            this.destination_direction.city = response.data[0].state +", " + response.data[0].city
          else
            this.destination_direction.city = response.data[0].state
        })
      }

      this.destination_direction.colony = this.destination.input.split('-')[1].trim()

      this.weightTotal = this.getWeightTotal(this.requestBody.parcels)
    },
    calculateQuote () {
      console.log('calculateQuote')
      console.log(this.parcels)
      if (this.package_type === 'document') {
        this.parcels[0].height = '41'
        this.parcels[0].width = '31'
        this.parcels[0].depth = '1'
        this.parcels.length = 1
      }
      this.requestBody.parcels = this.parcels
      this.requestBody.origin_direction = this.formatAddress(this.origin.country_code, this.origin.input)
      this.requestBody.destination_direction = this.formatAddress(this.destination.country_code, this.destination.input)
      this.requestBody.package_type = this.package_type
      this.requestBody.user = this.idUser
      this.initialValue();
      this.setQuotingRequestBody(this.requestBody)
      this.nextStep()

      this.quoting()
        .then(() => {
          this.listAllShippingOptions()
        })
        .catch(error => console.log(error))
    },

    createShipment () {
      this.$v.origin_direction.$touch()
      this.$v.destination_direction.$touch()
      this.$v.description_of_the_content.$touch()
      if (this.$v.origin_direction.$invalid || this.$v.destination_direction.$invalid || this.$v.description_of_the_content.$invalid) {
        return
      }
      this.newShip = true;
      this.setSelectedShippingOption(
        this.visibleShipmentOptions[this.selectedShippingOptionIndex]
      );
      if (this.ecommerceShipment) {
        this.shipment_ecommerce = {
          order_id: this.ecommerceShipment.numberOfOrde
            ? this.ecommerceShipment.numberOfOrde
            : null,
          ecommerce_type: this.ecommerceShipment.ecommerce_type
            ? this.ecommerceShipment.ecommerce_type
            : null
        };
      }
      console.log(this.countryDes);
      this.destination_direction.country_code = this.countryDes;
      this.origin_direction.address =    this.origin_direction.address + ', ' +  this.origin_direction.number + (this.origin_direction.intNumber.length > 0 ?  ', ' + this.origin_direction.intNumber : '')
      this.destination_direction.address =    this.destination_direction.address + ', ' +  this.destination_direction.number + (this.destination_direction.intNumber.length > 0 ?  ', ' + this.destination_direction.intNumber : '')

      const requestBody = {
        selected_service: {
          carrier: this.selectedShippingOption.carrier,
          date: this.selectedShippingOption.date,
          carrier_logo_url: this.selectedShippingOption.carrier_logo_url,
          carrier_logo_url_svg: this.selectedShippingOption.carrier_logo_url_svg,
          net_total_amount: this.selectedShippingOption.net_total_amount,
          total_amount: parseFloat(this.selectedShippingOption.total_amount) + parseFloat(this.cost_overweight),
          estimated_delivery: this.selectedShippingOption.estimated_delivery,
          total_transit_days: this.selectedShippingOption.total_transit_days,
          carrier_service_name: this.selectedShippingOption
            .carrier_service_name,
          carrier_code: this.selectedShippingOption.carrier_code
            ? this.selectedShippingOption.carrier_code
            : "",
          currency: this.selectedShippingOption.currency
        },
        shipment_type: this.package_type,
        parcels: this.quotingRequestBody.parcels,
        origin_direction: this.origin_direction,
        destination_direction: this.destination_direction,
        description_of_the_content: this.description_of_the_content,
        package_insurance: this.package_insurance,
        insurance_information: this.insurance_information,
        customer_info:
        {
          email: this.user.email,
          first_names: this.user.first_names,
          last_names: this.user.last_names
        },
        user: this.idUser,
        shipment_ecommerce: this.shipment_ecommerce
      }

      axios
        .post(`${commons.apiURL}/api/v1/shipments/home`, requestBody)
        .then(response => {
          this.shipmentId = response.data._id;
          this.getLinkPaypal();
          this.getLinkPaypalPlus();
          this.nextStep();
          this.setNewShipmentEcommerce(null);

          if(this.saveLocationOrigen)
          {
            this.registerAdressOrigen();
          }
          if(this.saveLocationDestination)
          {
            this.registerAdressDestination();
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    setSaveLocationOrigen()
    {
      this.saveLocationOrigen = !this.saveLocationOrigen;
    },
    setSaveLocationDestination()
    {
      this.saveLocationDestination = !this.saveLocationDestination;
    },
    registerAdressDestination()
    {
      axios
        .post(`${commons.apiURL}/api/v1/locations-user`, {
          name: this.destination_direction.full_name,
          email: this.destination_direction.email,
          phone: this.destination_direction.phone,
          address: this.destination_direction.address,
          colony: this.destination_direction.colony.trim().trim(),
          reference_of_origin: this.destination_direction.reference_of_origin,
          postal_code: this.destination_direction.postal_code.trim(),
          city: this.getCity(this.destination_direction.city.trim()),
          user: this.idUser,
          country_code: this.destination_direction.country_code
        })
        .then(response => {
            console.log('destination save');
        })
        .catch(error => {
          console.error(error)
        })
    },
    registerAdressOrigen()
    {
      axios
        .post(`${commons.apiURL}/api/v1/locations-user`, {
          name: this.origin_direction.full_name,
          email: this.origin_direction.email,
          phone: this.origin_direction.phone,
          address: this.origin_direction.address,
          colony: this.origin_direction.colony.trim(),
          reference_of_origin: this.origin_direction.reference_of_origin,
          postal_code: this.origin_direction.postal_code.trim(),
          city: this.getCity(this.origin_direction.city.trim()),
          user: this.idUser,
          country_code: this.origin_direction.country_code
        })
        .then(response => {
              console.log('origen save');
        })
        .catch(error => {
          console.error(error)
        })
    },

    deleteShipment() {
      this.newShip = false;
      axios
        .delete(`${commons.apiURL}/api/v1/shipments/${this.shipmentId}`)
        .then(response => {
          this.prevStep();
        })
        .catch(error => {
          console.error(error);
        });
    },
    getLinkPaypal(){
      axios
        .post(
          `${commons.apiURL}/api/v1/payments/${this.shipmentId}?email=${this.user.email}`
        )
        .then(response => {
          this.paypalLink = response.data.url;
        });
    },
    getLinkPaypalPlus(){
      service.shipment.getPaypalLink(this.shipmentId).then((response)=>{
        let data = response.data.data;
        if (data) {
         this.paypalpluslink = data.link;
         this.payment_id = data.payment_id;
        }
      }).catch((error)=>{
        this.paypalpluslink = ""
      })
    },
    getStatusSesion() {
      if (localStorage.getItem("ew-user-id") !== null) {
        this.idUser = localStorage.getItem("ew-user-id");
          console.log(this.idUser);
        this.isLoging = true;
      } else {
        this.idUser = null;
        this.isLoging = false;
      }
    },

    checkAddressOrigin (event) {
      // console.log(event)
      const query = event.target.value
      if (query.length >= 3 &&  query.length <= 7) {
        this.getLocationInfo(query, 'MX').then(response => {

          this.results = response.data.country_codes
          if (this.results.length > 0) {
            this.isOpen= true
            this.isLoading = true
          } else {
            this.isOpen= false
            this.isLoading = false
          }
        })
      }
    },
    checkAddressDestination (event) {
      const query = event.target.value
      if (query.length >= 3 && query.length <= 7) {
        this.getLocationInfo(query, 'MX').then(response => {
           this.resultsDes = response.data.country_codes

          if (this.resultsDes.length > 0) {
            this.isOpenDes= true
            this.isLoadingDes = true
          } else {
            this.isOpenDes= false
            this.isLoadingDes = false
          }
        })
      }
    },
    getLocationInfo (zipCode, countryCode) {
      return axios.get(
        `${
          commons.apiURL
        }/api/v1/postalcodes?search=${zipCode}&country=${countryCode}`
      )
    },
    ...mapMutations([
      'netNewShipmentRequestBody',
      'setQuotingRequestBody',
      'setSelectedShippingOption',
      'setNewShipmentRequestBody',
      'setShippingOptions',
      'setNewShipmentEcommerce'
    ]),
    ...mapActions(['quoting', 'newShipment', 'getAllShipments']),
    onArrowDown() {
      try {

        if (this.arrowCounter <= this.results.length - 1 && this.isOpen) {
          if (this.arrowCounter === this.results.length - 1) {
            this.scroll = 0
            this.arrowCounter = 0;
            this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
            this.scrollTo(this.scroll);
          } else {
            if (this.arrowCounter < 0) {
              this.arrowCounter = this.arrowCounter + 1;
              this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
              this.scroll = 0
              this.scrollTo(this.scroll);
            } else {
              this.arrowCounter = this.arrowCounter + 1;
              this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
              this.scroll = this.scroll + 30

              this.scrollTo(this.scroll);
            }
          }
      }

      if (this.arrowCounter > this.results.length -1 && this.isOpen) {
        this.arrowCounter = 0;
      }

      } catch (error) {
        console.log("Jesus", error)
      }
    },
    onArrowUp() {


        if (this.arrowCounter === 0) {
            this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
            this.arrowCounter = this.arrowCounter - 1;
            this.scroll = this.scroll - 30
            this.scrollTo(this.scroll);
        }

        if (this.arrowCounter > 0 && this.isOpen) {
          this.arrowCounter = this.arrowCounter - 1;
          this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
          this.scroll = this.scroll - 30
          this.scrollTo(this.scroll);

        }

        if (this.arrowCounter < 0 && this.isOpen) {
          this.arrowCounter = this.results.length -1;
          this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
          this.scroll = (30 * this.results.length -1 ) - 30
          this.scrollTo(this.scroll);
        }


    },
    onEnter() {

      this.origin.input = this.results[this.arrowCounter].postal_code + ' - ' + this.results[this.arrowCounter].place_name + ' - ' + this.results[this.arrowCounter].city;
      this.isOpen = false;
      this.arrowCounter = -1;
    },
    setResult(result) {

      this.origin.input = result.postal_code + ' - ' + result.place_name + ' - ' + result.city;
      this.isOpen = false;
    },
    selectLocation(i)
    {
      var locationOrigin = this.locations[i];
      console.log(locationOrigin);
      var address = locationOrigin.address.split(',')
      this.origin.input = locationOrigin.postal_code.trim() + ' - '+ locationOrigin.colony.trim() + ' - '+ locationOrigin.city.trim()
      this.origin_direction.full_name = locationOrigin.name
      this.origin_direction.email = locationOrigin.email
      this.origin_direction.phone = locationOrigin.phone
      this.origin_direction.address = address[0]
      this.origin_direction.number = address.length > 1 ? address[1] : ''
      this.origin_direction.intNumber = address.length > 2 ? address[2] : ''
      this.origin_direction.reference_of_origin = locationOrigin.reference_of_origin
      console.log(locationOrigin);
    },
    selectLocationDes(i)
    {
      var locationsDes = this.locationsDes[i];
      var address = locationsDes.address.split(',')
      this.destination.input = locationsDes.postal_code.trim() + ' - '+ locationsDes.colony.trim() + ' - '+ locationsDes.city.trim()
      this.destination_direction.full_name = locationsDes.name
      this.destination_direction.email = locationsDes.email
      this.destination_direction.phone = locationsDes.phone
      this.destination_direction.address = address[0]
      this.destination_direction.number =  address.length  > 1 ? address[1] : ''
      this.destination_direction.intNumber = address.length  > 2 ? address[2] : ''
      this.destination_direction.reference_of_origin = locationsDes.reference_of_origin
      console.log(locationsDes);
    },

    scrollTo(coord){

      let element = document.getElementById('autocomplete-results-das');
      element.scrollTo(0,coord)
    },

     setResultDes(result) {
      this.destination.input = result.postal_code + ' - ' + result.place_name + ' - ' + result.city;
      this.isOpenDes = false;
    },
    onArrowDownDes() {

      if (this.arrowCounterDes <= this.resultsDes.length - 1 && this.isOpenDes ) {
         if (this.arrowCounterDes === this.resultsDes.length - 1) {
            this.scrollDes = 0
            this.arrowCounterDes = 0;
            this.destination.input = this.resultsDes[this.arrowCounterDes].postal_code + ' - ' + this.resultsDes[this.arrowCounterDes].place_name + ' - ' + this.resultsDes[this.arrowCounterDes].city;
            this.scrollToDes(this.scrollDes);
         } else {

           if (this.arrowCounterDes < 0) {
              this.arrowCounterDes = this.arrowCounterDes + 1;
              this.destination.input = this.resultsDes[this.arrowCounterDes].postal_code + ' - ' + this.resultsDes[this.arrowCounterDes].place_name + ' - ' + this.resultsDes[this.arrowCounterDes].city;
              this.scrollDes = 0
              this.scrollToDes(this.scrollDes);
           } else {

             this.arrowCounterDes = this.arrowCounterDes + 1;
             this.destination.input = this.resultsDes[this.arrowCounterDes].postal_code + ' - ' + this.resultsDes[this.arrowCounterDes].place_name + ' - ' + this.resultsDes[this.arrowCounterDes].city;
             this.scrollDes = this.scrollDes + 30
             this.scrollToDes(this.scrollDes);
           }
         }
      }

      if (this.arrowCounterDes > this.resultsDes.length -1 && this.isOpenDes) {
        this.arrowCounterDes = 0;
      }

    },
    onArrowUpDes() {
        if (this.arrowCounterDes === 0) {
          this.destination.input = this.resultsDes[this.arrowCounterDes].postal_code + ' - ' + this.resultsDes[this.arrowCounterDes].place_name + ' - ' + this.resultsDes[this.arrowCounterDes].city;
          this.arrowCounterDes = this.arrowCounterDes - 1;
          this.scrollDes = this.scrollDes - 30
          this.scrollToDes(this.scrollDes);
        }
        if (this.arrowCounterDes > 0 && this.isOpenDes) {

            this.scrollDes = this.scrollDes - 30
            this.arrowCounterDes = this.arrowCounterDes - 1;
            this.destination.input = this.resultsDes[this.arrowCounterDes].postal_code + ' - ' + this.resultsDes[this.arrowCounterDes].place_name + ' - ' + this.resultsDes[this.arrowCounterDes].city;
            this.scrollToDes(this.scrollDes);

        }

        if (this.arrowCounterDes < 0 && this.isOpenDes) {
          this.arrowCounterDes = this.resultsDes.length -1;
          this.destination.input = this.resultsDes[this.arrowCounterDes].postal_code + ' - ' + this.resultsDes[this.arrowCounterDes].place_name + ' - ' + this.resultsDes[this.arrowCounterDes].city;
          this.scrollDes = (30 * this.resultsDes.length -1 ) - 30
          this.scrollToDes(this.scrollDes);
        }


    },
    onEnterDes() {
      this.destination.input = this.resultsDes[this.arrowCounterDes].postal_code + ' - ' + this.resultsDes[this.arrowCounterDes].place_name + ' - ' + this.resultsDes[this.arrowCounterDes].city;
      this.isOpenDes = false;
      this.arrowCounterDes = -1;
    },
    scrollToDes(coord){
      let element = document.getElementById('autocomplete-results-des');
      element.scrollTo(0,coord)
    },
    getCity(directions){
        if (directions.indexOf(",") >= 0) {
          let city = directions.split(",")
          if (city.length > 1) {
            return city[1].trim()
          }
        } else {
        return directions;
        }
    },
    getWeightTotal(parcels){
      let total = 0
      parcels.forEach(element => {
        total = total + parseFloat(element.weight)
      });
      return total
    },
     setOrigin (country) {
      this.origin = country
    },
    handleClickOutside(evt) {

      if (evt.target.id !== "resultOrigin") {
        this.isOpen = false;
        this.isLoading = false;
        this.arrowCounter = 0;
        this.scroll = 0;
      }
      if (evt.target.id !== "resultDestination") {
        this.isOpenDes = false;
        this.isLoadingDes = false;
        this.arrowCounterDes = 0;
        this.scrollDes = 0;
      }
    },
    addEventPixeleFacebook() {
      fbq("track", "InitiateCheckout");
    },
    setDocument() {
      this.package_type = "document";
      // Mismas medidas fijas que calculateQuote() ya forzaba justo antes de
      // cotizar (41×31×1) — se adelantan aquí para que los campos, ahora
      // deshabilitados en vez de ocultos, muestren de una vez la medida real
      // que se va a usar en vez de quedar vacíos o con un valor viejo.
      this.parcels[0].width = '31'
      this.parcels[0].height = '41'
      this.parcels[0].depth = '1'
    },
    setBox() {
      this.package_type = "box";
      this.parcels[0].width = ''
      this.parcels[0].height = ''
      this.parcels[0].depth = ''
    },
    initIframePayPalPlus(){
      this.paypalplay = PAYPAL.apps.PPP({
        approvalUrl: this.paypalpluslink,
        placeholder: "ppplusDiv",
        mode: "live",
        payerEmail:`${this.user.email}`,
        payerFirstName: `${this.user.first_names}`,
        payerLastName: `${this.user.last_names}`,
        payerPhone: `${this.origin_direction.phone}`,
        payerTaxId: "",
        payerTaxIdType: "",
        country: "MX",
        language:"es_MX",
        miniBrowser:true,
        buttonLocation:"inside",
        disallowRememberedCards:true,
        onMiniBrowserClose:function () {
          console.log("close")
        },
        onContinue:(rememberedCards, payer_id, token) => {
          let email = this.user.email;
          api.shipment.executePayment(this.payment_id, payer_id, this.shipmentId, email).then((response)=>{
            let data = response.data.data;
            if (data.execute) {
                this.$router.push({path: `/payments/result/success?home=true&email=${email}`});
            }else{
                this.$router.push({path: "/payments/result/error"});
            }
          }).catch((error)=>{
              this.$router.push({path: "/payments/result/error"});
          })
        },
        onError: function (err) {
          this.$router.push({path: "/payments/result/error"});
        },
        onLoad:function(){
          console.log("carga realizada con exito")
        }
      });
    },
  },
  computed: {
    currentStep () {
      return this.step
    },
    ...mapGetters([
      'quotingRequestBody',
      'selectedShippingOption',
      'serviceProviders',
      'shippingOptions',
      'isLoadingShippingOptions',
      "ecommerceShipment",
      "countryDes"
    ]),

  },
  validations: {
    origin_direction: {
      full_name: { required, minLength: minLength(2), maxLength: maxLength(35) },
      phone: { required },
      email: { required, email },
      address: { required, minLength: minLength(2), maxLength: maxLength(25) },
      number: { required },
      colony: { required, maxLength: maxLength(35) },
      postal_code: { required, maxLength: maxLength(12) }
    },
    destination_direction: {
      full_name: { required, minLength: minLength(2), maxLength: maxLength(35) },
      phone: { required },
      email: { required, email },
      address: { required, minLength: minLength(2), maxLength: maxLength(25) },
      number: { required },
      colony: { required, minLength: minLength(5), maxLength: maxLength(35) },
      postal_code: { required, maxLength: maxLength(12) }
    },
    description_of_the_content: { required }
  },
  created () {

    /** Verificar que tipo de envios se cotizara */
    if (this.ecommerceShipment) {
      this.destination_direction.full_name = this.ecommerceShipment
        .destination_direction.full_name
        ? this.ecommerceShipment.destination_direction.full_name
        : "";
      this.destination_direction.email = this.ecommerceShipment
        .destination_direction.email
        ? this.ecommerceShipment.destination_direction.email
        : "";
      this.destination_direction.phone = this.ecommerceShipment
        .destination_direction.phone
        ? this.ecommerceShipment.destination_direction.phone
        : "";
      this.destination_direction.address = this.ecommerceShipment
        .destination_direction.address
        ? this.ecommerceShipment.destination_direction.address
        : "";
    }


    axios.get(`${commons.apiURL}/api/v1/countrycodes`).then(response => {
      this.countries = response.data.country_codes
      this.quotingLocked=false
      // console.log(response.data.country_codes)
    })
    this.getStatusSesion();
    if (localStorage.getItem('ew-user-id') !== null) {
      axios
      .get(`${commons.apiURL}/api/v1/users/${localStorage.getItem('ew-user-id')}`)
      .then(response => {
        this.user.email = response.data.email
        this.user.first_names = response.data.firstName
        this.user.last_names = response.data.lastName
        this.user.active = response.data.active
        console.log(this.user.email);
      }).catch(error => {
          console.trace(error)
          alert(error);
      });
      axios
        .get(`${commons.apiURL}/api/v1/locations-user?user=${localStorage.getItem('ew-user-id')}`)
        .then(response => {
            this.locations = response.data
            this.locationsDes = response.data
            for(var i = 0; i<this.locations.length; i++)
            {
              var op = {
               id : i,
               text: this.locations[i].name + ' '+  this.locations[i].address + ' ' +  this.locations[i].colony + ' C.P.'+  this.locations[i].postal_code
               };
              this.optionsOrigen.push(op);
              this.optionsDestination.push(op);
            }
        })
        .catch(error => {
          console.error(error)
        })

    }
    else
    {
      console.log('Sin sessión')
      alert('Sin sessión')
    }
  },
  mounted(){
    document.addEventListener("click", this.handleClickOutside);
  },
  destroyed(){
    document.removeEventListener("click", this.handleClickOutside);
  },
  components: {
    'navbar-dashboard': Navbar,
    'Select2': Select2,
    'ph-icon': PhIcon
  }
}
</script>

<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-page { @include app-tokens; }
.ew-page__body { padding: 1.75rem 2rem 2.5rem; }
.ew-card { @include ew-card; }
.ew-wizard { padding: 1.5rem 1.75rem 2rem; }
.ew-card-title { @include ew-card-title; margin-bottom: 1rem; }
.ew-section-title {
  margin: 0 0 1.25rem;
  font-family: var(--app-font);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--app-navy);
}

/* Stepper -------------------------------------------------------------- */
.ew-stepper { @include ew-stepper; }
.ew-stepper__step { @include ew-stepper-step; }
.ew-stepper__index { @include ew-stepper-index; }
.ew-stepper__line { @include ew-stepper-line; }

/* Formularios compartidos ------------------------------------------------ */
.ew-form__field { display: flex; flex-direction: column; gap: 0.4rem; margin-bottom: 1rem; }
.ew-form__field--relative { position: relative; }
.ew-form__row { display: flex; flex-wrap: wrap; gap: 1rem; > .ew-form__field { flex: 1 1 160px; min-width: 0; } }
.ew-label { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-navy); }
.ew-input { @include ew-input; }
.ew-field-error { @include ew-field-error; }
.ew-input--block { width: 100%; }
.ew-checkbox-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.25rem;
  font-family: var(--app-font);
  font-size: 0.85rem;
  color: var(--app-navy-secondary);
  cursor: pointer;
}
.ew-checkbox { @include ew-checkbox; }
.ew-wizard__actions {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 1.5rem;
  &--end { justify-content: flex-end; }
}
.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }

.ew-pay-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  // El mixin compartido atenúa el botón deshabilitado con opacity; aquí
  // "deshabilitado por saldo insuficiente" se ve gris, pero "procesando"
  // se queda con el color sólido y el spinner, para no leer como error.
  &:disabled:not(.is-loading) {
    opacity: 1;
    background: var(--app-surface-muted);
    color: var(--app-muted);
    cursor: not-allowed;
  }
  &.is-loading:disabled {
    opacity: 1;
    cursor: progress;
  }
}

.ew-pay-submit .ew-spinner {
  width: 1rem;
  height: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: ew-spin .7s linear infinite;
}

/* Paso 1: origen/destino + Select2 --------------------------------------- */
// Punto de quiebre alto a propósito: esta cuadrícula vive dentro de
// .ew-step-layout__main, que ya perdió ~330px al sidebar (17rem) + la
// columna de resumen (19rem + gap). Con el quiebre viejo de 800px, entre
// ~960-1300px de viewport el contenido disponible real bajaba a ~250-400px
// y las dos columnas quedaban aplastadas — de ahí el reporte de "formularios
// deformes". Al ser un media query de viewport (no de contenedor), hay que
// calcular el quiebre asumiendo el peor caso (sidebar + aside presentes).
// minmax(0, 1fr) y no 1fr a secas: un track de grid en 1fr todavía tiene
// min-width:auto implícito (se calcula del contenido), así que aunque toda
// la cadena de abajo (.ew-select2, .select2-selection, etc.) ya tenga
// min-width:0, el propio panel-columna se negaba a encogerse por debajo del
// ancho de una dirección larga sin espacios para cortar — reventando toda
// la cuadrícula en vez de solo truncar el texto seleccionado.
.ew-addr-grid { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 1.25rem; margin-bottom: 1.5rem; @media (max-width: 1320px) { grid-template-columns: minmax(0, 1fr); } }
.ew-form-panel { padding: 1.25rem; border: 1px solid var(--app-border); border-radius: var(--app-radius-md); background: #fff; }
.ew-form-panel__title { margin: 0 0 1rem; font-family: var(--app-font); font-weight: 700; color: var(--app-navy); }

// min-width:0 en toda la cadena: .ew-select2 es un hijo flex de
// .ew-form__field (flex-direction:column), y un item flex en columna trae
// por default min-width:auto — es decir, nunca se encoge más allá del
// ancho de su CONTENIDO. Con una dirección larga seleccionada (texto sin
// espacios para cortar), eso reventaba el combo (y con él toda la
// cuadrícula de dos columnas) en vez de respetar el 100% previsto. El
// texto ahora se corta con "…" en vez de desbordar.
.ew-select2 {
  min-width: 0;
  /deep/ .select2-container { width: 100% !important; min-width: 0; }
  /deep/ .select2-selection {
    height: 2.75rem !important;
    border: 1px solid var(--app-border) !important;
    border-radius: var(--app-radius-sm) !important;
    display: flex;
    align-items: center;
    min-width: 0;
  }
  /deep/ .select2-selection__rendered {
    font-family: var(--app-font);
    font-size: 0.9rem;
    color: var(--app-navy);
    line-height: 2.75rem !important;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.ew-cp-group { display: flex; gap: 0.5rem; align-items: center; }
// El selector de país se quitó (ver PENDIENTES.md): en la práctica solo
// México funcionaba, un dropdown "interactivo" que no cambia nada es peor
// que no tener dropdown. Queda como insignia fija informativa.
.ew-flag-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  height: 2.75rem;
  padding: 0 0.75rem;
  border: 1px solid var(--app-border);
  border-radius: var(--app-radius-sm);
  background: #fff;
  font-family: var(--app-font);
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--app-navy);

  &--header {
    height: auto;
    padding: 0.2rem 0.5rem;
    border: none;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
  }
}
.ew-flag { width: 1.25rem; height: auto; border-radius: 2px; }

.ew-autocomplete {
  position: absolute;
  z-index: 20;
  top: 100%;
  left: 0;
  right: 0;
  margin: 0.25rem 0 0;
  padding: 0.35rem 0;
  list-style: none;
  max-height: 12rem;
  overflow-y: auto;
  background: #fff;
  border: 1px solid var(--app-border);
  border-radius: var(--app-radius-sm);
  box-shadow: 0 8px 20px rgba(7, 50, 88, 0.12);
}
.ew-autocomplete__item {
  padding: 0.5rem 0.9rem;
  font-family: var(--app-font);
  font-size: 0.85rem;
  color: var(--app-navy-secondary);
  cursor: pointer;
  &:hover, &.is-active { background: var(--app-surface-muted); }
}

/* Tipo de paquete + dimensiones ------------------------------------------ */
.ew-package-type { text-align: center; margin-bottom: 1.5rem; }
.ew-package-type__title { font-family: var(--app-font); font-weight: 700; color: var(--app-navy); margin-bottom: 0.75rem; }
.ew-package-type__options { display: flex; justify-content: center; gap: 0.75rem; }
.ew-radio-pill {
  display: inline-flex;
  align-items: center;
  height: 2.5rem;
  padding: 0 1.25rem;
  border: 1.5px solid var(--app-border);
  border-radius: 999px;
  font-family: var(--app-font);
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--app-navy);
  cursor: pointer;

  input { margin-right: 0.5rem; }
  &:has(input:checked) { border-color: var(--app-accent); background: var(--app-surface-muted); }
}

.ew-parcels { margin-bottom: 1.5rem; }
.ew-parcels__row { display: flex; flex-wrap: wrap; gap: 1rem; margin-bottom: 0.75rem; > .ew-form__field { flex: 1 1 140px; min-width: 0; margin-bottom: 0; } }
.ew-parcels__hint { text-align: center; font-family: var(--app-font); font-size: 0.8rem; color: var(--app-muted); }

.ew-insurance-teaser { text-align: center; margin-bottom: 0.5rem; }
.ew-insurance-teaser__text { font-family: var(--app-font); color: var(--app-navy); margin-bottom: 0.5rem; }
.ew-icon-simbol { width: 1rem; height: auto; margin-left: 0.25rem; }
.ew-insurance-teaser .ew-checkbox-row { justify-content: center; }

/* Loading ----------------------------------------------------------------*/
.ew-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  padding: 4rem 1.5rem;
  text-align: center;
  font-family: var(--app-font);
  font-weight: 700;
  color: var(--app-navy);

  img { width: 4rem; height: auto; }
}

/* Paso 2: selección de servicio ------------------------------------------ */
.ew-carrier-list { display: flex; flex-direction: column; gap: 0.9rem; }
.ew-carrier-card { @include ew-carrier-card; }
.ew-carrier-card__logo { @include ew-carrier-card-logo; }
.ew-carrier-card__info { @include ew-carrier-card-info; }
.ew-carrier-card__price { @include ew-carrier-card-price; }
.ew-area-remote { color: #C8102E; }

.ew-price-breakdown { min-width: 12rem; font-family: var(--app-font); font-size: 0.82rem; }
.ew-price-breakdown__row { display: flex; justify-content: space-between; gap: 1rem; padding: 0.2rem 0; color: var(--app-navy-secondary); }
.ew-price-breakdown__total { display: flex; justify-content: space-between; gap: 1rem; padding-top: 0.4rem; margin-top: 0.3rem; border-top: 1px solid var(--app-border); font-weight: 700; color: var(--app-navy); }

.ew-empty { @include ew-empty; }
.ew-empty__title { @include ew-empty-title; }
.ew-empty__text { @include ew-empty-text; }

/* Resumen del pedido: presente en los 4 pasos, columna derecha ----------- */
.ew-step-layout { display: grid; grid-template-columns: 1fr 19rem; align-items: start; gap: 1.5rem; @media (max-width: 960px) { grid-template-columns: 1fr; } }
.ew-step-layout__aside { @media (max-width: 960px) { order: -1; } }

.ew-address-panel { border-radius: var(--app-radius-md); overflow: hidden; }
.ew-address-panel__header { @include ew-address-panel-header; }
.ew-address-panel__body { @include ew-address-panel-body; }

.ew-content-card { margin-bottom: 1.5rem; }

.ew-summary-card { @include ew-summary-card; }
.ew-summary-card__carrier {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid var(--app-border);
  img { width: 4rem; height: auto; }
  p { margin: 0; font-family: var(--app-font); font-weight: 700; color: var(--app-navy); font-size: 0.9rem; }
}
.ew-summary-route { margin-bottom: 1rem; }
.ew-summary-route__row {
  display: flex;
  gap: 0.75rem;
  font-family: var(--app-font);
  font-size: 0.85rem;
  color: var(--app-navy-secondary);
  margin-bottom: 0.5rem;
  span:first-child { font-weight: 700; color: var(--app-navy); flex-shrink: 0; }
  p { margin: 0; }
}
.ew-summary-row { @include ew-summary-row; }
.ew-summary-total { @include ew-summary-total; }

/* Paso 4: pago ------------------------------------------------------------*/
.ew-pay-card { display: flex; flex-direction: column; }
.ew-pay-options { display: flex; flex-direction: column; gap: 0.75rem; margin-bottom: 1rem; }
.ew-pay-option {
  @include ew-pay-option;
  &.is-disabled { opacity: 0.55; cursor: not-allowed; &:hover { background: none; } }
}
.ew-pay-option__hint { display: block; font-size: 0.72rem; font-weight: 600; color: #C8102E; }
.ew-pay-hint {
  margin: -0.25rem 0 1rem;
  padding: 0.65rem 0.85rem;
  border-radius: var(--app-radius-sm);
  background: var(--app-surface-muted);
  font-family: var(--app-font);
  font-size: 0.8rem;
  color: var(--app-navy-secondary);
}
.ew-pay-security {
  margin: 0.85rem 0 0;
  font-family: var(--app-font);
  font-size: 0.75rem;
  color: var(--app-muted);
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/NewShipmentFlowFromDashboard.vue